export default __webpack_public_path__ + "static/media/search.db065a6e.svg";